import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { LotWatchRequestBuyModalComponent } from './components/lot-watch-request-buy-modal/lot-watch-request-buy-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Lot, LotSource, LotTypeEnum } from '../../graphql/service/graphql-auto-main-service';
import { LotWatchRequestInspectionData } from '../../../services/auction-video-watch/types/lot-watch-request-inspection-data.type';
import { AuctionService } from '../../../services/auction.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lot-watch-request-buy-button',
  templateUrl: './lot-watch-request-buy-button.component.html',
  styleUrls: ['./lot-watch-request-buy-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotWatchRequestBuyButtonComponent implements OnInit, OnDestroy {
  @Input() savedLot: Lot;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Input() fullSize = false;
  @Input() inspectionData: LotWatchRequestInspectionData;
  @Input() lotShared: EventEmitter<void>;

  inspectionId?: number;

  private subscription = Subscription.EMPTY;

  constructor(
    private readonly translate: TranslateService,
    private readonly modalService: NzModalService,
    private readonly auctionService: AuctionService,
  ) {}

  ngOnInit(): void {
    this.subscription = this.auctionService
      .getByName(this.savedLot?.auctionName)
      .subscribe((auction) => (this.inspectionId = auction?.auctionData?.inspectionId));
  }

  openLotWatchRequestBuyModal(): void {
    this.modalService.create({
      nzTitle: this.translate.instant('LOT_WATCH_REQUEST_BUY_BUTTON.TITLE'),
      nzContent: LotWatchRequestBuyModalComponent,
      nzComponentParams: {
        lot: this.savedLot,
        lotType: this.lotType,
        lotSource: this.lotSource,
        lotShared: this.lotShared,
        inspectionId: this.inspectionId,
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
